import { render, staticRenderFns } from "./EstatisticasCredito.vue?vue&type=template&id=40b70f34&scoped=true&"
import script from "./EstatisticasCredito.vue?vue&type=script&lang=js&"
export * from "./EstatisticasCredito.vue?vue&type=script&lang=js&"
import style0 from "./EstatisticasCredito.vue?vue&type=style&index=0&id=40b70f34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b70f34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VOverlay,VProgressCircular})
